import Input from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import Checkbox from "./Checkbox";
import DatePicker from "./DatePicker";
import Buttons from "./Buttons";

export const Controls = {
  Input,
  RadioGroup,
  Select,
  Checkbox,
  DatePicker,
  Buttons
};
